import {
  DynamicLinkType,
  FlexibleBlockBrickButton,
  FlexibleBlockBrickImage,
  FlexibleBlockBrickLink,
  FlexibleBlockBrickRating,
  FlexibleBlockBrickRatingStyle,
  FlexibleBlockBrickText,
  FlexibleBlockBrickTitle,
  FlexibleBlockProps,
  FlexibleBlockTemplateCustom,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';

export const getCustomBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateCustom>[] => {
  let brickIndex = -1;

  const brickCommon = {
    index: 0,
    enabled: true,
    sortable: true,
    removable: true,
    switchable: true,
  };

  const brickDescription: FlexibleBlockBrickText = {
    ...brickCommon,
    brickType: 'text',
    brickName: 'Paragraph',
    text: 'Here you can find detailed information about the person who will know everything about your project.',
    placeholder: 'Here, you can add description',
    className: ['p-0', 'text-lg'],
    theme: { text: { main: PortalTextType.SURFACE } },
    index: ++brickIndex,
  };

  const brickImage: FlexibleBlockBrickImage = {
    ...brickCommon,
    brickType: 'image',
    brickName: 'Image',
    src: '/assets/img/blocks/image/avatar-male.png',
    className: [],
    index: ++brickIndex,
  };

  const brickHeading: FlexibleBlockBrickTitle = {
    ...brickCommon,
    brickType: 'title',
    brickName: 'Heading',
    text: 'Vito One',
    placeholder: 'Here, you can add heading',
    className: ['p-0', 'text-xl', 'font-bold'],
    theme: { text: { main: PortalTextType.SURFACE } },
    index: ++brickIndex,
  };

  const brickDescription_2: FlexibleBlockBrickText = {
    ...brickCommon,
    brickType: 'text',
    brickName: 'Paragraph',
    text: '8 years of experience.',
    placeholder: 'Here, you can add description',
    className: ['p-0', 'text-lg'],
    theme: { text: { main: PortalTextType.SURFACE } },
    index: ++brickIndex,
  };

  const brickHeading_2: FlexibleBlockBrickTitle = {
    ...brickCommon,
    brickType: 'title',
    brickName: 'Heading',
    text: 'Rating',
    placeholder: 'Here, you can add heading',
    className: ['p-0', 'text-xl', 'font-bold'],
    theme: { text: { main: PortalTextType.SURFACE } },
    index: ++brickIndex,
  };

  const brickRating: FlexibleBlockBrickRating = {
    ...brickCommon,
    brickType: 'rating',
    brickName: 'Rating',
    style: FlexibleBlockBrickRatingStyle.STAR,
    value: 5,
    colored: false,
    className: ['p-0', 'justify-start'],
    index: ++brickIndex,
  };

  const brickDescription_3: FlexibleBlockBrickText = {
    ...brickCommon,
    brickType: 'text',
    brickName: 'Paragraph',
    text: '5/5 based on 133 ratings',
    placeholder: 'Here, you can add description',
    className: ['p-0', 'text-lg'],
    theme: { text: { main: PortalTextType.SURFACE } },
    index: ++brickIndex,
  };

  const brickLink: FlexibleBlockBrickLink = {
    ...brickCommon,
    brickType: 'link',
    brickName: 'Link',
    dynamicLink: {
      type: DynamicLinkType.EXTERNAL,
      title: 'Linkedin Link',
      url: 'https://www.linkedin.com/',
    },
    className: ['p-0', 'text-lg'],
    index: ++brickIndex,
    theme: {
      text: {
        main: PortalTextType.SURFACE,
      },
    },
  };

  const brickButton: FlexibleBlockBrickButton = {
    ...brickCommon,
    brickType: 'button',
    brickName: 'Button',
    switchable: true,
    text: 'Book a Call',
    dynamicLink: { type: DynamicLinkType.EXTERNAL, url: 'https://zoom.us/' },
    index: ++brickIndex,
  };

  return [
    {
      title: 'Your Consultant',
      wrapper: getWrapperProps('blank'),
      template: {
        type: 'custom',
        view: 'basic',
      },
      bricks: [
        brickDescription,
        brickImage,
        brickHeading,
        brickDescription_2,
        brickHeading_2,
        brickRating,
        brickDescription_3,
        brickLink,
        brickButton,
      ],
      className: ['gap-4'],
    },
  ];
};
